const timeRe = /\d\d:\d\d/;

export class DayTime {
  static Parse(val: string) {
    if (!timeRe.test(val)) {
      throw new Error("invalid time format. Should be hh:mm");
    }

    const [hoursStr, minutesStr] = val.split(":");
    const seconds = (parseInt(hoursStr) * 60 + parseInt(minutesStr)) * 60;
    return new DayTime(seconds);
  }

  // internal representation of day time
  private readonly seconds: number = 0;

  constructor(seconds: number) {
    if (seconds < 0 || seconds >= 86400) {
      throw new Error("invalid number of seconds");
    }

    this.seconds = seconds;
  }

  toSeconds() {
    return this.seconds;
  }

  toString() {
    const hours = Math.floor(this.seconds / 3600);
    const minutes = Math.floor(this.seconds % 3600) / 60;

    const hoursStr = hours < 10 ? `0${hours.toString()}` : hours.toString();
    const minutesStr = minutes < 10 ? `0${minutes.toString()}` : minutes.toString();

    return `${hoursStr}:${minutesStr}`;
  }

  toDate(date: Date) {
    const [hours, minutes] = this.toString().split(":");
    const d = new Date(date);
    d.setHours(parseInt(hours), parseInt(minutes));
    return d;
  }

  toJSON() {
    return {
      seconds: this.seconds,
      asString: this.toString()
    };
  }
}
